import {Rank} from '/constant/TestIDs';
import {
  INTEGRATED_NATIONAL_DIRECTOR,
  INTEGRATED_REGIONAL_DIRECTOR,
} from '/enum/rank.enum';
import {withTranslation} from '/provider/TranslationProvider';

import NumericData from '../../NumericData';

const tt = (key: any, value: any) =>
  withTranslation.tt(`rankProgressCard.executiveDirectorTeams.${key}`, value);

export default {
  dataComponent: NumericData,
  dataComponentProps: {
    getTitle: () => tt('text', 'Frontline Qualifying Volume'),
  },
  extendedDataComponent: undefined,
  extendedDataComponentProps: {},
  isComplete: ({current, target}: any) =>
    parseInt(current, 10) >= parseInt(target, 10),
  hasExtendedDetail: false,
  presentedFor: [INTEGRATED_REGIONAL_DIRECTOR, INTEGRATED_NATIONAL_DIRECTOR],
  testID: Rank.rankFQV,
};
